import PropTypes from "prop-types";
import { InputNumber } from "top-component-library";
import { FormRow } from "../styles";

const OrderRateLimitRateLimitStep = ({ maxOrdersPerDesiredTime, onChange }) => (
  <div>
    <h4>Order Limit Per Time Slot:</h4>
    <FormRow>
      <label htmlFor="max-orders-per-desired-time">Number of Orders</label>
      <InputNumber
        id="max-orders-per-desired-time"
        min={1}
        max={10000}
        step={1}
        placeholder="10"
        value={maxOrdersPerDesiredTime ?? undefined}
        onChange={onChange}
      />
    </FormRow>
  </div>
);

OrderRateLimitRateLimitStep.propTypes = {
  maxOrdersPerDesiredTime: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

OrderRateLimitRateLimitStep.defaultProps = {
  maxOrdersPerDesiredTime: null,
};

export default OrderRateLimitRateLimitStep;
